module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_4_preview.caa0fbdd.jpg";